// src/pages/SearchPage.js
import React, { useState, useEffect, useMemo, useRef } from "react";
import {
	Box,
	useColorModeValue,
	useDisclosure,
} from "@chakra-ui/react";
import SearchBar from "../components/SearchBar";
import GoogleMapComponent from "../components/GoogleMapComponent";
import LoginModal from "../components/LoginModal";
import OnboardingModal from "../components/Onboarding";
import axios from "axios";


const SearchPage = () => {
	const [searchParams, setSearchParams] = useState(null);
	const [photographers, setPhotographers] = useState([]);
	// const [filteredPhotographers, setFilteredPhotographers] = useState([]); // Commented out filtering
	const [loading, setLoading] = useState(false);
	// const [sortOption, setSortOption] = useState(""); // Commented out sorting
	const [searchLocation, setSearchLocation] = useState(null);
	// Chakra UI Drawer control
	const { isOpen, onOpen, onClose } = useDisclosure();
	// Colors for better contrast
	const bgColor = useColorModeValue("gray.100", "gray.900");
	const drawerBg = useColorModeValue("white", "blackAlpha.900");
	const hasFetched = useRef(false); // ✅ Track if request was made
	const [showTrustPrompt, setShowTrustPrompt] = useState(false);
	const [showLoginModal, setShowLoginModal] = useState(false);
	const [showOnboardingModal, setShowOnboardingModal] = useState(false);
	const [isLoggedIn, setIsLoggedIn] = useState(() => {
		return !!localStorage.getItem("token");
	});

	useEffect(() => {
		const timer = setTimeout(() => {
			const isAuthenticated = !!localStorage.getItem("token");
			if (!isAuthenticated) {
				setShowLoginModal(true);
			}
		}, 7000); // 7 seconds delay

		return () => clearTimeout(timer);
	}, []);



	const backendUrl =
		process.env.NODE_ENV === "production"
			? process.env.REACT_APP_BACKEND_URL
			: "http://localhost:8080";

	useEffect(() => {
		if ("geolocation" in navigator && !hasFetched.current) {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					const { latitude, longitude } = position.coords;
					const location = { lat: latitude, lng: longitude };
					setSearchLocation(location);

					if (!hasFetched.current) {
						hasFetched.current = true; // ✅ Prevent multiple requests
						fetchPhotographers({
							location,
							date: new Date(), // ✅ Use today's date by default
							startTime: "08:00 AM", // ✅ Default Start Time
							endTime: "10:00 PM",   // ✅ Default End Time
						});
					}
				},
				(error) => {
					console.error("Location error:", error);
				},
				{ enableHighAccuracy: true, maximumAge: 0 }
			);
		}
	}, []); // ✅ Runs only when the component mounts

	// ✅ Updated fetchPhotographers function (unchanged but optimized)
	const fetchPhotographers = async (params) => {
		try {
			if (!params.location) return; // ✅ Prevent empty location requests
			setLoading(true);

			const { location, date, startTime, endTime } = params;
			const fromDate = date?.toDateString();
			const fromTime = startTime;
			const toDate = date?.toDateString();
			const toTime = endTime;

			const response = await axios.get(`${backendUrl}/search`, {
				params: {
					location: `${location.lat},${location.lng}`,
					fromDate,
					fromTime,
					toDate,
					toTime,
				},
			});

			setPhotographers(response.data);
			localStorage.setItem("photographers", JSON.stringify(response.data));
		} catch (error) {
			console.error("Error fetching photographers:", error);
			setPhotographers([]);
		}
		setLoading(false);
	};

	// ✅ Handle search submission (unchanged)
	const handleSearch = (params) => {
		setSearchParams(params);
		fetchPhotographers(params);
	};


	return (
		<Box p={2}>
			{/* Google Map Component (Behind Drawer) */}
			<SearchBar onSearch={handleSearch} searchLocation={searchLocation} setSearchLocation={setSearchLocation} />
			<Box position="absolute" bottom="0" left="0" right="0" zIndex="0">
				<GoogleMapComponent searchLocation={searchLocation} photographers={photographers} />
			</Box>


			{/* Sorting UI Commented Out */}
			{/* <HStack mt={4} spacing={4}>
        <Select placeholder="Sort By" onChange={handleSortChange}>
          <option value="price-low">Price: Low to High</option>
          <option value="rating-high">Rating: High to Low</option>
        </Select>
      </HStack> */}

			{/* 🧲 Trust Prompt */}
			<LoginModal
				isOpen={showLoginModal}
				onClose={() => { }}
				setIsLoggedIn={(value) => setIsLoggedIn(value)}
				onLoginSuccess={() => setShowLoginModal(false)}
				onSignUp={() => {
					setShowLoginModal(false);      // Close the login modal
					setShowOnboardingModal(true);  // Open onboarding modal
				}}
			/>


			{/* 🧩 Onboarding Signup */}
			{showOnboardingModal && (
				<OnboardingModal
					isOpen={showOnboardingModal}
					onClose={() => setShowOnboardingModal(false)}
					setIsLoggedIn={setIsLoggedIn}
				/>
			)}


		</Box>
	);
};

export default SearchPage;
